import { isFixedRuleResponse, isFixedRulesResponse, isFixedRuleVersionsResponse, } from '@urbanik/api-contracts';
export class FixedRulesApiError extends Error {
    kind;
    constructor(kind, message) {
        super(message);
        this.kind = kind;
        this.name = 'FixedRulesApiError';
    }
}
const endpoint = (base, path = '') => `${base.replace(/\/$/, '')}/identity/governance/rules${path}`;
async function call(base, path, init) {
    let response;
    try {
        response = await fetch(endpoint(base, path), {
            credentials: 'include',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            ...init,
        });
    }
    catch {
        throw new FixedRulesApiError('unavailable', 'No pudimos conectar con el servidor.');
    }
    const body = await response.json();
    if (!response.ok) {
        const message = typeof body === 'object' &&
            body !== null &&
            typeof body.message === 'string'
            ? body.message
            : 'No pudimos completar la operación.';
        throw new FixedRulesApiError(response.status === 401
            ? 'unauthorized'
            : response.status === 403
                ? 'forbidden'
                : response.status === 404
                    ? 'not-found'
                    : response.status === 409
                        ? 'conflict'
                        : response.status === 400
                            ? 'validation'
                            : 'unavailable', message);
    }
    return body;
}
export async function getFixedRules(base, signal) {
    const body = await call(base, '', { signal: signal ?? null });
    if (!isFixedRulesResponse(body))
        throw new FixedRulesApiError('invalid', 'El catálogo de reglas recibido no es válido.');
    return body;
}
export async function createFixedRule(base, input) {
    const body = await call(base, '', { method: 'POST', body: JSON.stringify(input) });
    if (!isFixedRuleResponse(body))
        throw new FixedRulesApiError('invalid', 'La regla creada no es válida.');
    return body;
}
export async function getFixedRuleVersions(base, ruleId, signal) {
    const body = await call(base, `/${encodeURIComponent(ruleId)}/versions`, {
        signal: signal ?? null,
    });
    if (!isFixedRuleVersionsResponse(body))
        throw new FixedRulesApiError('invalid', 'La línea temporal recibida no es válida.');
    return body;
}
export async function createFixedRuleVersion(base, ruleId, input) {
    const body = await call(base, `/${encodeURIComponent(ruleId)}/versions`, {
        method: 'POST',
        body: JSON.stringify(input),
    });
    if (!isFixedRuleResponse(body))
        throw new FixedRulesApiError('invalid', 'La nueva versión recibida no es válida.');
    return body;
}
export async function setFixedRuleLifecycle(base, ruleId, annulled, reason) {
    const body = await call(base, `/${encodeURIComponent(ruleId)}/${annulled ? 'annul' : 'restore'}`, { method: 'POST', body: JSON.stringify({ reason: reason ?? null }) });
    if (!isFixedRuleResponse(body))
        throw new FixedRulesApiError('invalid', 'El estado recibido de la regla no es válido.');
    return body;
}
